import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=695a13b2&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleSearchBar: require('/vercel/path0/components/articles/ArticleSearchBar.vue').default,ArticleCard: require('/vercel/path0/components/articles/ArticleCard.vue').default,ArrowLeftLight: require('/vercel/path0/components/icons/ArrowLeftLight.vue').default})
